export const AUTH_TOKEN = 'auth_token';
export const AUTH_CANDIDATE_PATH = (token: string): string =>
  `api_auth/sign_in_candidate_with_token?token=${token}`;
export const AUTH_COMPANY_USER_PATH = (token: string): string =>
  `/api_auth/sign_in_company_user_with_token?token=${token}`;
